function setColumn(option,field, prop, val) {
    const { found, config } = getFieldConfig(option,field);
    if (found) {
      Reflect.set(config, prop, val);
      if(prop==='display'&&val===false){
       delete option[field]
      }
    } else {
    }
  }
  function getColumn(option,field) {
    const { found, config } = getFieldConfig(option,field);
    if (found) {
      return config;
    } else {
      return undefined
    }
  }
    function getFieldConfig(option,field) {
    // 检查参数有效性
    if (!option || !field) {
      return {
        found: false,
        config: null,
      };
    }

    // 查找 `columns` 中的配置
    if (option.columns && Array.isArray(option.columns)) {
      const columnConfig = option.columns.find((col) => col.field === field);
      if (columnConfig) {
        return {
          found: true,
          config: columnConfig,
        };
      }
    }

    // 查找 `groups` 中的配置
    if (option.groups && Array.isArray(option.groups)) {
      for (const group of option.groups) {
        if (group.columns && Array.isArray(group.columns)) {
          const groupColumnConfig = group.columns.find((col) => col.field === field);
          if (groupColumnConfig) {
            return {
              found: true,
              config: groupColumnConfig,
              group: group.label, // 可选：返回所属分组的标签
            };
          }
        }
      }
    }

    return {
      found: false,
      config: null,
    };
  }
  export { setColumn, getColumn, getFieldConfig }